import React, { useState, useMemo } from "react";
import { logoutIamRedirectUrl } from "config";
import AuthContext from "context/authContext";

function AuthProvider({ children }) {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")));

  const setUserData = (data) => {
    localStorage.setItem("user", JSON.stringify(data));
    setUser(data);
  };

  const removeUserData = () => {
    localStorage.removeItem("user");
    setUser(null);
  };

  const getLogoutRedirectUrl = () =>
    user != null && user.destinationRef != null
      ? `${logoutIamRedirectUrl}?destinationRef=${user.destinationRef.toLowerCase()}`
      : logoutIamRedirectUrl;

  const authValue = useMemo(
    () => ({ user, setUserData, removeUserData, getLogoutRedirectUrl }),
    [user, setUserData, removeUserData, getLogoutRedirectUrl]
  );

  return <AuthContext.Provider value={authValue}>{children}</AuthContext.Provider>;
}

export default AuthProvider;
